{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/ItemList.schema.json",
  "title": "schema.org ItemList object",
  "type": "object",
  "properties": {
    "type": {
      "oneOf": [
        {
          "type": "string",
          "const": "ItemList"
        },
        {
          "type": "array",
          "items": {
            "type": "string"
          },
          "contains": {
            "const": "ItemList"
          }
        }
      ]
    },
    "itemListElement": {
      "type": ["array"],
      "items": {
        "type": "string"
      }
    }
  },
  "required": ["type", "itemListElement"]
}
